import React, { ReactElement } from "react";
import { FullReportEntry } from "../models/FullReportEntry";
import { bigNumber } from "../utils/money-utils";


function Funnel({title, number}:{title:string|ReactElement, number:number}){
    return <div className="funnel-item">
        <div>
            <div className="label">{title}</div>
            <div className="number">{bigNumber(number)}</div>
        </div>
    </div>
}

export function AccountFunnel({account}:{account:FullReportEntry}){
    return <div className="funnel mb-3">
        <Funnel title="Impressões" number={account.impressions} />
        <Funnel title="Alcance" number={account.reach} />
        {account.clicks > 0 && <Funnel title="Clicks" number={account.clicks} />}
        <Funnel title="Leads" number={account.nLeads} />
    </div>
}